import { Link as RouterLink } from "react-router-dom";
import { Box, Flex, Image, Link, Text } from "@chakra-ui/react";

const MUTED = "rgba(15,22,38,0.55)";
const INK = "#0a0e1a";
const BORDER = "rgba(15,22,38,0.08)";

const LINKS = [
  { label: "About", to: "/about-us" },
  { label: "Contact", to: "/contact-us" },
  { label: "Privacy", to: "/privacy" },
  { label: "Terms", to: "/terms" },
];

const FooterLink = ({ to, children }) => (
  <Link
    as={RouterLink}
    to={to}
    fontSize="13px"
    color={MUTED}
    textDecoration="none"
    transition="color .2s"
    _hover={{ color: INK, textDecoration: "none" }}
  >
    {children}
  </Link>
);

const MarketingFooter = () => (
  <Box
    as="footer"
    bg="#f7fafc"
    borderTop="1px solid"
    borderColor={BORDER}
    px={{ base: "20px", md: "28px" }}
    pt="48px"
    pb="28px"
  >
    <Box maxW="1280px" mx="auto">
      <Flex
        direction={{ base: "column", md: "row" }}
        align={{ base: "flex-start", md: "center" }}
        justify="space-between"
        gap="24px"
      >
        <Box>
          <Image
            src="/spearbi_ai1.jpg"
            alt="SpearBI"
            h="40px"
            objectFit="contain"
            borderRadius="6px"
          />
          <Text
            mt="12px"
            color={MUTED}
            fontSize="13px"
            lineHeight="1.55"
            maxW="320px"
          >
            Sales reporting for retail brands. Every store, every SKU, every
            retailer feed — connected.
          </Text>
        </Box>

        <Flex gap="24px" wrap="wrap">
          {LINKS.map((l) => (
            <FooterLink key={l.to} to={l.to}>
              {l.label}
            </FooterLink>
          ))}
        </Flex>
      </Flex>

      <Box
        mt="32px"
        pt="20px"
        borderTop="1px solid"
        borderColor={BORDER}
        fontSize="12px"
        color={MUTED}
      >
        © {new Date().getFullYear()} SpearBI. All rights reserved.
      </Box>
    </Box>
  </Box>
);

export default MarketingFooter;
